import { Component, OnDestroy, OnInit, PipeTransform } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { PublicHeaderService } from '@carm/base-layout/main/public-header.service';
import { Observable } from 'rxjs';
import { delay, map, startWith, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { CarmRouter } from '@carm/_core/carm-router/services/carm-router.service';
import { BaseComponent } from '@carm/_utils/base.component';
import { RoleTypes } from '@carm/_core';
import { AuthService } from '@carm/_auth/spartacus/core/auth';

@Component({
  selector: 'carm-main-header-main-section',
  templateUrl: './main-header-main-section.component.html',
  styleUrls: ['./main-header-main-section.component.scss'],
})
export class MainHeaderMainSectionComponent extends BaseComponent implements OnInit, OnDestroy {

  isNoShown: boolean;
  isLoggedIn$: Observable<boolean>;
  isPublic: boolean;
  isShow$: Observable<string | boolean>;
  env: string;
  roleType$: Observable<string>;
  programType$: Observable<string>;
  dashboardLink = RoutesConst.PortalRegistrationStatus;
  firstNativeRole$: Observable<string>;
  isSetupMyPortal: boolean;
  showEnvironmentHeader = environment.showEnvironmentHeader;

  constructor(private userService: UserService,
              private authService: AuthService,
              private router: CarmRouter,
              public publicHeaderService: PublicHeaderService) {

   super();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd ) {
        this.isNoShown = this.publicHeaderService.isLoggedExclusion(event);
        this.isPublic = this.publicHeaderService.publicHeader(event);
        this.isSetupMyPortal = event.url.includes("setup-my-portal") ||
        event.url.includes("personal-profile") ||
        event.url.includes("cbsa-enrolment-mgt");

        if(this.isSetupMyPortal) {
          this.userService.toggleProgramSwitchMenu(false)
        }else{
          this.userService.toggleProgramSwitchMenu(true)
        }
        this.dashboardLink = !!this.router.bn9 ? RoutesConst.Dashboard : RoutesConst.PortalRegistrationStatus;
      }
    });
  }

  ngOnInit() {

    if(environment.showEnvironmentHeader) {
      this.env = environment.name;
      this.roleType$ = this.userService.getUserLastUsedRoleType().pipe(
        map(role => (role === RoleTypes.Orphan ? 'Unassociated User' : role)),
        takeUntil(this.destroy$),
        startWith(null as string),
        delay(0));

      this.programType$ = this.userService.getLastUsedProgramType().pipe(
        takeUntil(this.destroy$),
        startWith(null as string),
        delay(0));

      this.firstNativeRole$ = this.userService.getNativeRoles().pipe(
        takeUntil(this.destroy$),
        delay(0), map(role => (role.length > 0 ? role[0].roleName : '')));
    }

    this.isLoggedIn$ = this.authService.isUserLoggedIn().pipe(takeUntil(this.destroy$));
    this.isShow$ = this.userService.showProgramSwitchMenu().pipe(
      takeUntil(this.destroy$),
      startWith(null as string),
      delay(0));
  }
}

export class ReplaceUnderscorePipe implements PipeTransform {
  transform(value: string): string {
    return value ? value.replace(/_/g, " ") : value;
  }
}
